import React from 'react';
import { StyledAppName, StyledIcon, StyledPageWrapper } from './style';
export var PageWrapper = function (_a) {
    var appName = _a.appName, children = _a.children, _b = _a.icon, Icon = _b === void 0 ? null : _b;
    return (React.createElement(StyledPageWrapper, null,
        Icon && React.createElement(StyledIcon, null, Icon),
        React.createElement(StyledAppName, null,
            React.createElement("span", null, "Gismart"),
            appName && React.createElement("span", null, appName)),
        children));
};
//# sourceMappingURL=PageWrapper.js.map